<template>
  <div id="dacb-message-list" class="dacb-message-list">
    <transition name="fade">
      <span v-if="hasShadow" class="dacb-shadow"></span>
    </transition>

    <div id="message-list-scrollable" class="dacb-scrollable" @scroll="onScroll">
      <div v-for="message in messages" :key="message.id">
        <message :message="message" />
        <location-panel v-if="message.location" :location="message.location" />
      </div>
      <reply-dots @toggled="doScroll()"></reply-dots>
      <span ref="cursor" class="dacb-cursor"></span>
    </div>
  </div>
</template>

<script>
import LocationPanel from "components/LocationPanel.vue";
import Message from "components/Message.vue";
import ReplyDots from "components/ReplyDots.vue";
import bus from "helpers/bus";
import _ from "underscore";
import { mapState } from "vuex";

export default {
  name: "MessageList",

  components: { Message, ReplyDots, LocationPanel },

  data() {
    return {
      firstOpen: true,
      messagesCount: 0,
      hasShadow: false,
      replying: false
    };
  },

  computed: {
    ...mapState({
      messages: (state) => state.messages.all
    })
  },

  watch: {
    messages: {
      handler(newValue) {
        if (newValue.length > this.messagesCount) {
          this.messagesCount = newValue.length;
          this.doScroll(this.firstOpen ? 10 : 500);
        }
      },
      deep: true
    }
  },

  created() {
    bus.$on("messageList:doScroll", this.doScroll);
  },

  mounted() {
    this.doScroll(10);
  },

  unmounted() {
    bus.$off("messageList:doScroll", this.doScroll);
  },

  methods: {
    doScroll: _.debounce(function (speed = 500) {
      this.$nextTick(() => {
        this.$scrollTo(this.$refs.cursor, speed, {
          container: "#dacb-message-list"
        });
      });
    }, 50),

    onScroll(event) {
      this.hasShadow = event.target.scrollTop > 0;
    }
  }
};
</script>
